var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseFiveIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0625 20.6875L31.25 28.5L18.75 25.375L7.8125 17.5625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1953 4.79492L25 1.9375L35.8047 4.79492",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71287 2.80081L1.72849 12.7735C1.54325 13.1439 1.51264 13.5727 1.64338 13.9656C1.77413 14.3586 2.05553 14.6836 2.42576 14.8692L7.81248 17.5625L14.1953 4.79495L8.81052 2.10354C8.62702 2.01151 8.42718 1.95655 8.22243 1.94179C8.01767 1.92703 7.81202 1.95276 7.61721 2.01751C7.42241 2.08227 7.24227 2.18477 7.0871 2.31917C6.93193 2.45358 6.80476 2.61724 6.71287 2.80081Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 17.5625L47.5742 14.8692C47.9444 14.6836 48.2258 14.3586 48.3566 13.9656C48.4873 13.5727 48.4567 13.1439 48.2715 12.7735L43.2871 2.80081C43.1952 2.61724 43.068 2.45358 42.9129 2.31917C42.7577 2.18477 42.5776 2.08227 42.3828 2.01751C42.188 1.95276 41.9823 1.92703 41.7775 1.94179C41.5728 1.95655 41.373 2.01151 41.1895 2.10354L35.8047 4.79495L42.1875 17.5625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9374 5.0625H28.1249L19.2069 13.7129C19.0412 13.8786 18.9148 14.0795 18.8372 14.3006C18.7596 14.5218 18.7327 14.7576 18.7586 14.9906C18.7845 15.2235 18.8624 15.4477 18.9867 15.6464C19.111 15.8452 19.2784 16.0134 19.4765 16.1387C22.8964 18.3242 27.539 18.1738 31.2499 14.4375L39.0624 20.6875L42.1874 17.5625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2305 33.1875L16.082 31.1504L10.9375 27.4746",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseFiveIcon3);
export default __webpack_public_path__ + "static/media/why-choose-five-icon-3.3f11085bbe31aea2515094355432e3d1.svg";
export { ForwardRef as ReactComponent };